const reportList = [
    {
        id: 'harassment',
        name: 'Harassment',
    },
    {
        id: 'fraud-scam',
        name: 'Fraud or scam',
    },
    {
        id: 'misinformation',
        name: 'Misinformation',
    },
    {
        id: 'self-harm',
        name: 'Self-harm',
    },
    {
        id: 'spam',
        name: 'Spam',
    },
    {
        id: 'hateful-speech',
        name: 'Hateful speech',
    },
    {
        id: 'violence-threat',
        name: 'Threats of violence',
    },
    {
        id: 'fake-account',
        name: 'Fake Account',
    },
    {
        id: 'child-exploit',
        name: 'Child Exploitation',
    },
    {
        id: 'sexual-content',
        name: 'Sexual content',
    },
    {
        id: 'danger',
        name: 'Dangerous Organisation',
    }
];

export default reportList;